//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.ExtrudeBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"CutColor",1,0],[0,"CutView",1,"ModelingView",0],[1,"Extrude",0,"Features.ExtrudeBuilder",0],[0,"HatchAngle",1,0],[0,"HatchDistance",1,0],[0,"MaterialOutsideLoop",1,0],[0,"SaveAsName",1,0],[1,"TargetComponents",0,"SelectDisplayableObjectList",0],[0,"ToolBody",1,"Body",0],[0,"UseCutColor",1,0],[0,"UseCutHatch",1,0],[0,"UseSaveAs",1,0]],[[[],"RecalculateLimits",{},0,0],[["target_components"],"SetTargetComponents",{},1,0],[["num_target_components"],"GetTargetComponents",{R_:{target_components:"DisplayableObject[]"}},0,0],[["direction","limit_1","limit_2"],"CalcThroughLimits",{},1,0]],[]];
SPLM.Features.MasterCutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MasterCutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;